import {
  PageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { apiDocsPlugin } from '@backstage/plugin-api-docs';

export const apiDocsModule = createFrontendModule({
  pluginId: 'api-docs',
  extensions: [
    // ── Route (→ app/routes) ────────────────────────────────
    PageBlueprint.make({
      params: {
        path: '/api-docs',
        noHeader: true,
        routeRef: apiDocsPlugin.routes.root,
        loader: () =>
          import('@backstage/plugin-api-docs').then(m => (
            <m.DefaultApiExplorerPage />
          )),
      },
    }),
  ],
});
